/**
 * @generated SignedSource<<fbfa6950ad8f47951c4d1d1cf56183a2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type accessWarenannahmeQuery$variables = {
  accessToken: string;
};
export type accessWarenannahmeQuery$data = {
  readonly anonymousUtilizationGrant: {
    readonly deactivatedAt: any | null | undefined;
    readonly id: string;
    readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
    readonly reservation: {
      readonly contentNote: string | null | undefined;
      readonly id: string;
      readonly note: string | null | undefined;
      readonly space: {
        readonly configuration: SpaceConfiguration;
        readonly dimensions: {
          readonly depthMm: number;
          readonly heightMm: number;
          readonly widthMm: number;
        };
        readonly frame: string;
        readonly hub: {
          readonly id: string;
          readonly meta: {
            readonly city: string;
            readonly id: string;
            readonly lat: number;
            readonly lng: number;
            readonly name: string;
            readonly postalCode: string;
            readonly street: string;
          } | null | undefined;
          readonly spaces: ReadonlyArray<{
            readonly frame: string;
          }>;
          readonly status: HubStatus;
        };
        readonly position: number;
      };
    };
  };
};
export type accessWarenannahmeQuery = {
  response: accessWarenannahmeQuery$data;
  variables: accessWarenannahmeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessToken"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accessToken",
        "variableName": "accessToken"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "anonymousUtilizationGrant",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deactivatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LockReservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "note",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "position",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "configuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OutputDimensions",
                "kind": "LinkedField",
                "name": "dimensions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "widthMm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "heightMm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "depthMm",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "hub",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubMeta",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      (v1/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "street",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postalCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lng",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v5 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v6 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v7 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v8 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accessWarenannahmeQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "accessWarenannahmeQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "9ed397d2df7aeb5c722b3b10364b6423",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "anonymousUtilizationGrant": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrant"
        },
        "anonymousUtilizationGrant.deactivatedAt": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "DateTime"
        },
        "anonymousUtilizationGrant.id": (v4/*:: as any*/),
        "anonymousUtilizationGrant.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "anonymousUtilizationGrant.reservation": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservation"
        },
        "anonymousUtilizationGrant.reservation.contentNote": (v5/*:: as any*/),
        "anonymousUtilizationGrant.reservation.id": (v4/*:: as any*/),
        "anonymousUtilizationGrant.reservation.note": (v5/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Space"
        },
        "anonymousUtilizationGrant.reservation.space.configuration": {
          "enumValues": [
            "BACE_STOREFRONT_S",
            "BACE_STOREFRONT_M",
            "BACE_STOREFRONT_L",
            "BACE_STOREFRONT_XL",
            "BACE_STOREFRONT_2XL",
            "BACE_SATELLITE_SMALL_STANDARD",
            "BACE_SATELLITE_SMALL_SLIM",
            "BACE_SATELLITE_SMALL_EXTENDED",
            "BACE_SATELLITE_MEDIUM_STANDARD",
            "BACE_SATELLITE_MEDIUM_EXTENDED",
            "BACE_SATELLITE_LARGE_STANDARD",
            "BACE_SATELLITE_LARGE_EXTENDED",
            "BACE_CLATTERING_STANDARD",
            "BACE_TRUCK_HUB_STANDARD",
            "THALIA_RENZ_STANDARD_XS",
            "THALIA_RENZ_STANDARD_S",
            "THALIA_RENZ_STANDARD_M",
            "THALIA_RENZ_WIDE_S",
            "THALIA_RENZ_WIDE_M"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceConfiguration"
        },
        "anonymousUtilizationGrant.reservation.space.dimensions": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "OutputDimensions"
        },
        "anonymousUtilizationGrant.reservation.space.dimensions.depthMm": (v6/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.dimensions.heightMm": (v6/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.dimensions.widthMm": (v6/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.frame": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Hub"
        },
        "anonymousUtilizationGrant.reservation.space.hub.id": (v4/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "anonymousUtilizationGrant.reservation.space.hub.meta.city": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.id": (v4/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.lat": (v8/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.lng": (v8/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.name": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.postalCode": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.street": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.spaces": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Space"
        },
        "anonymousUtilizationGrant.reservation.space.hub.spaces.frame": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "anonymousUtilizationGrant.reservation.space.position": (v6/*:: as any*/)
      }
    },
    "name": "accessWarenannahmeQuery",
    "operationKind": "query",
    "text": "query accessWarenannahmeQuery(\n  $accessToken: String!\n) {\n  anonymousUtilizationGrant(accessToken: $accessToken) {\n    id\n    deactivatedAt\n    permissions\n    reservation {\n      id\n      contentNote\n      note\n      space {\n        frame\n        position\n        configuration\n        dimensions {\n          widthMm\n          heightMm\n          depthMm\n        }\n        hub {\n          id\n          status\n          spaces {\n            frame\n          }\n          meta {\n            id\n            name\n            street\n            city\n            postalCode\n            lat\n            lng\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4daf019eb7b0f3856d781de1fcc3edcb";

export default node;
